const clamp = (value, min, max) => Math.min(Math.max(value, min), max);

const getPercentageFromPosition = (position, clientRect) => {
  const length = clientRect.width;
  if (length === 0) return 0;
  const sizePerc = position.x / length;

  return sizePerc || 0;
};

const getValueFromPosition = (position, minValue, maxValue, clientRect) => {
  const sizePerc = getPercentageFromPosition(position, clientRect);
  const valueDiff = maxValue - minValue;
  const value = minValue + valueDiff * sizePerc;

  return value;
};

const getValueFromProps = (props, isMultiValue) => {
  if (isMultiValue) {
    return props.value;
  }

  return {
    min: props.minValue,
    max: props.value
  };
};

const getPercentageFromValue = (value, minValue, maxValue) => {
  if (maxValue === minValue) return 0;
  const validValue = clamp(value, minValue, maxValue);
  const valueDiff = maxValue - minValue;
  const valuePerc = (validValue - minValue) / valueDiff;

  return valuePerc || 0;
};

const getPercentagesFromValues = (values, minValue, maxValue) => {
  const percentages = {
    min: getPercentageFromValue(values.min, minValue, maxValue),
    max: getPercentageFromValue(values.max, minValue, maxValue)
  };

  return percentages;
};

const getPositionFromValue = (value, minValue, maxValue, clientRect) => {
  const sizePerc = getPercentageFromValue(value, minValue, maxValue);
  const length = clientRect.width;
  const position = {
    x: sizePerc * length,
    y: 0
  };

  return position;
};

const getPositionsFromValues = (values, minValue, maxValue, clientRect) => {
  const positions = {
    min: getPositionFromValue(values.min, minValue, maxValue, clientRect),
    max: getPositionFromValue(values.max, minValue, maxValue, clientRect)
  };

  return positions;
};

const getPositionFromEvent = (event, clientRect) => {
  const { pageX } = "touches" in event ? event.touches[0] : event;
  const position = {
    x: clamp(pageX - clientRect.left, 0, clientRect.width),
    y: 0
  };

  return position;
};

const getStepValueFromValue = (value, valuePerStep) => {
  if (valuePerStep === 0) return value;

  return Math.round(value / valuePerStep) * valuePerStep;
};

export {
  getPercentageFromPosition,
  getValueFromPosition,
  getValueFromProps,
  getPercentageFromValue,
  getPercentagesFromValues,
  getPositionFromValue,
  getPositionsFromValues,
  getPositionFromEvent,
  getStepValueFromValue
};
